export default function GrvLogo({ className = '', textClassName = '', logoUrl = '', alt = 'GRV BUILD' }) {
  if (logoUrl) {
    return (
      <img
        src={logoUrl}
        alt={alt}
        className={`h-[1.75em] w-auto object-contain ${className}`}
      />
    );
  }

  return (
    <div className={`flex items-center gap-0 select-none ${className}`}>
      <span
        data-grv-logo-letter
        style={{
          fontFamily: "'Montserrat', sans-serif",
          fontWeight: 900,
          fontSize: 'inherit',
          letterSpacing: '-0.02em',
          lineHeight: 1,
        }}
      >
        G
      </span>
      <span
        data-grv-logo-letter
        style={{
          fontFamily: "'Montserrat', sans-serif",
          fontWeight: 900,
          fontSize: 'inherit',
          letterSpacing: '-0.02em',
          lineHeight: 1,
        }}
      >
        R
      </span>
      <span
        style={{
          fontFamily: "'Montserrat', sans-serif",
          fontWeight: 900,
          fontSize: 'inherit',
          letterSpacing: '-0.02em',
          lineHeight: 1,
          background: 'linear-gradient(135deg, #c9a227 0%, #f5d06a 50%, #c9a227 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
        }}
      >
        V
      </span>
      <span
        data-grv-logo-sub
        style={{
          fontFamily: "'Montserrat', sans-serif",
          fontWeight: 500,
          fontSize: '0.45em',
          letterSpacing: '0.2em',
          lineHeight: 1,
          marginLeft: '0.3em',
          marginTop: '0.15em',
        }}
        className={`uppercase self-end mb-1 ${textClassName}`}
      >
        BUILD
      </span>
    </div>
  );
}
